import React, { useContext, Fragment, useEffect } from "react";
import { MotivoPerdaContext } from "../MotivoPerdaContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarMotivoPerda = () => {
  const { values, setValues, resetScreen } = useContext(MotivoPerdaContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={MotivoPerdaContext}>
        <div className="col-12 col-md-4">
          <label>Descrição</label>
          <input
            className="form-control"
            type="text"
            name="motivoPerdaDescricao"
            value={values.searchData.motivoPerdaDescricao}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={MotivoPerdaContext} />
    </Fragment>
  );
};

export default PesquisarMotivoPerda;
